export default "__VITE_ASSET__46b0221f__"